/**
 * VISTOERA_SAAS_I18N_FOUNDATION V1 ? minimal canonical language switcher
 * (spec �17). One shared component so every Surface that needs a switcher
 * (today: the Workspace shell's account area) renders the exact same
 * options/behavior instead of a bespoke dropdown per page.
 *
 * Language names are always self-referential (spec �18 ? "????" /
 * "English" never re-translate into the *other* language when the UI
 * switches), so a user who switched by mistake can always find their way
 * back. Switching is instant (no reload ? spec �17
 * `FULL_PAGE_RELOAD_REQUIRED = NO`) and only calls `setLocale()`, which
 * never touches route/business state (spec �42).
 */
import { GlobalOutlined } from '@ant-design/icons'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_UI_LOCALES } from '../i18n/types'
import { useUiLocale } from '../i18n/LocaleProvider'

export default function LanguageSwitcher({ className }: { className?: string }) {
  const { locale, setLocale } = useUiLocale()
  const { t } = useTranslation('common')
  const { t: tNav } = useTranslation('navigation')

  return (
    // `data-testid` on a wrapper span (not passed to AntD `Select` itself,
    // which doesn't forward arbitrary DOM attributes to a stable single
    // node) ? E2E specs target this, not CSS classnames that may change.
    <span data-testid="language-switcher">
      <Select
        size="small"
        className={className}
        value={locale}
        onChange={setLocale}
        variant="borderless"
        suffixIcon={<GlobalOutlined />}
        aria-label={tNav('languageSwitcher.ariaLabel')}
        popupMatchSelectWidth={false}
        options={SUPPORTED_UI_LOCALES.map((code) => ({
          value: code,
          // Self-referential display name (spec �18) � each code's label
          // is read from `common.language.<code>` in the ACTIVE locale file,
          // and both locale files carry the identical self-name for every
          // code so the list stays stable when switching.
          label: t(`language.${code}`),
        }))}
      />
    </span>
  )
}
